<template>
  <CCard>
    <CCardHeader>
      <strong>New Topic</strong>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="12">
          <CInput label="Name" placeholder="Enter topic name" v-model="name" />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CSelect
            label="Category"
            :options="categories"
            :value.sync="selectedCategory"
            @change="getSubcategories"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CSelect
            label="SubCategory"
            :options="subcategories"
            :value.sync="selectedSubcategory"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CTextarea
            label="Description"
            placeholder="Enter topic description"
            v-model="description"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CInput
            label="Weight"
            type="number"
            placeholder="Enter Weight"
            v-model="weight"
          />
        </CCol>
      </CRow>
      <CRow>
        <CCol sm="12">
          <CInputFile
            label="Image thumbnail"
            vertical
            ref="file"
            type="file"
            id="file"
            @change="onImageChange"
          />
          <!--<input type="file" class="form-control" v-on:change="onImageChange">-->
          <label class="text-danger"
            >(Image Size should be (360 X 360) and less than 1 MB)</label
          >
        </CCol>
      </CRow>
    </CCardBody>
    <CCardFooter>
      <CButton @click="onSubmit" color="primary">
        <CIcon name="cil-check-circle" />Add Topic
      </CButton>
    </CCardFooter>
  </CCard>
</template>

<script>
const ADMIN_URL = process.env.VUE_APP_ADMIN_URL;
export default {
  name: "TopicCreate",
  data() {
    return {
      name: "",
      description: "",
      image: "",
      weight: 0,
      categories: [],
      subcategories: [],
      selectedCategory: 1,
      selectedSubcategory: null
    };
  },
  created() {
    this.getCategories();
    this.getSubcategories();
  },
  methods: {
    onImageChange(e) {
      console.log("event", e[0]);
      this.image = e[0];
    },
    onSubmit(e) {
      e.preventDefault();
      let currentObj = this;
      const config = {
        headers: {
          "content-type": "multipart/form-data",
          Accept: "application/json",
        },
      };

      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("description", this.description);
      formData.append("image", this.image);
      formData.append("weight", this.weight);
      if(this.selectedSubcategory==null)
      {
        formData.append("category_id", this.selectedCategory);
      }
      else
      {
        formData.append("category_id", this.selectedSubcategory);
      }
     

      this.$axios
        .post(`${ADMIN_URL}/topics`, formData, config)
        .then((response) => {
          console.log("Success", response);
          currentObj.success = response.data.success;
          console.log(response.data);
          this.$swal("Success", response.data.message, "success");
          window.location.href = "/topics";
        })
        .catch((error) => {
          console.log("Error  ... ", error.response);
          currentObj.output = error;
          this.$swal("Error", error.response.message, "error");
        });
    },
    getCategories() {
      this.$axios
        .get(`${ADMIN_URL}/categories`)
        .then((response) => {
          console.log("categories, response === ", response.data);
          let cats = response.data.category_list.filter((f) => {
            return f.parent == "";
          });
          cats.forEach((e) => {
            this.categories.push({
              value: e.id,
              label: e.name,
            });
          });
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
    getSubcategories() {
      this.subcategories = [{value: null, label: 'None'}]
      this.selectedSubcategory = null
      this.$axios
        .post(`${ADMIN_URL}/subcategories`,{
          category_id : this.selectedCategory
        })
        .then((response) => {
          console.log("subcategories, response === ", response.data);
         response.data.category_list.forEach((e) => {
            this.subcategories.push({
              value: e.id,
              label: e.name,
            });
          });
        })
        .catch((e) => {
          console.log("error occurs", e);
        });
    },
  },
};
</script>

<style scoped>
</style>
